//
// generated from "ErrorCodes.pd"
//

export enum ERR {
  OK = 0,
  FAIL = 1,
  NOT_IMPLEMENTED = 2,
  DEPREACTED = 3,
  VERSION_INVALID = 100,
  VERSION_OVER = 101,
  VERSION_UNDER = 102,
  UNKNOWN_PACKET = 1000,
  UNKNOWN_ERROR = 1001,
  MANY_PACKET_IN_TIME = 1002,
  DB_EXCEPTION = 2000,
  CACHE_EXCEPTION = 2001,
  INVALID_SESSION = 2002,
  INVALID_ACCOUNT = 2003,
  INVALID_PASSWORD = 2004,
  INVALID_LAUNCH_AUTHKEY = 2005,
  INVALID_AUTHKEY = 2006,
  NOT_AUTHENTICATED = 2007,
  ALREADY_LOGGEDIN = 2008,
  OVERLAPPED_SESSION_FAIL = 2009,
  PROCESSING_CLOSING_OLDS_SESSION = 2010,
  INVALID_PARAMETER = 2011,
  INVALID_LEADERBOARD_TYPE = 2012,
  YOU_ARE_BLOCKED = 2013,
  YOU_ARE_UNREGISTERED = 2014,
  STAFF_ONLY = 2015,
  RECEIVER_REJECT_MESSAGE = 2016,
  RECEIVER_REJECT_CLUB_MESSAGE = 2017,
  TABLE_NOT_FOUND = 2018,
  TABLE_VERSION_NOT_FOUND = 2019,
  NICKNAME_INVALID = 2020,
  NICKNAME_ALREADY_EXISTS = 2021,
  CHARACTER_ALREADY_EXISTS = 2022,
  DATA_NOT_FOUND = 2023,
  PROMISE_NOT_FOUND = 2024,
  USER_NOT_FOUND = 2025,
  ITEM_NOT_FOUND = 2026,
  CLUB_NOT_FOUND = 2027,
  BETTOR_NOT_FOUND = 2028,
  CLUB_RULES_NOT_FOUND = 2029,
  META_NOT_FOUND = 2030,
  MATCH_NOT_FOUND = 2031,
  MATCH_CHAT_NOT_FOUND = 2032,
  ODDS_NOT_FOUND = 2033,
  ODDSFIELD_NOT_FOUND = 2034,
  MANUAL_MARKET_ALREADY_EXISTS = 2035,
  MY_CLUB_NOT_FOUND = 2036,
  CLUB_MEMBER_NOT_FOUND = 2037,
  BETTOR_BET_NOT_FOUND = 2038,
  PICK_MARKET_NOT_FOUND = 2039,
  PICK_NOT_FOUND = 2040,
  PICK_PURCHASE_NOT_FOUND = 2041,
  CLUB_NOTICE_NOT_FOUND = 2042,
  RECORD_NOT_FOUND = 2043,
  ACCOUNT_LOCAL_NOT_FOUND = 2044,
  ACCOUNT_GOOGLE_NOT_FOUND = 2045,
  ACCOUNT_NOT_FOUND = 2046,
  INVALID_JOB = 2047,
  ALREADY_IN_PROGRESS = 2048,
  PRODUCT_INVALID_STATE = 2049,
  PRODUCT_NOT_FOUND = 2050,
  PRODUCT_JOB_LIMITED = 2051,
  PRODUCT_LEVEL_LIMITED = 2052,
  PRODUCT_INSUFFICIENT_CASH = 2053,
  PRODUCT_INSUFFICIENT_HEART = 2054,
  PRODUCT_INSUFFICIENT_MILEAGE = 2055,
  PRODUCT_INSUFFICIENT_POINT = 2056,
  PRODUCT_INVALID_PRICE_TYPE = 2057,
  PRODUCT_ALLOWED_ONE_INSTANCE = 2058,
  PRODUCT_GIFT_LIMITED = 2059,
  PRODUCT_EXCEPTION = 2060,
  CLUBNAME_ALREADY_EXISTS = 2061,
  OPEN_CLUB_BLOCKED = 2062,
  OPEN_CLUB_FAILED_NOT_BETTOR = 2063,
  OPEN_CLUB_INVALID_STATE = 2064,
  OPEN_CLUB_STATE_SEEK_APPROVAL = 2065,
  OPEN_CLUB_STATE_APPROVED = 2066,
  OPEN_CLUB_STATE_AGREED = 2067,
  OPEN_CLUB_STATE_RUNNING = 2068,
  OPEN_CLUB_STATE_SEEK_CLOSE = 2069,
  OPEN_CLUB_STATE_CLOSING = 2070,
  OPEN_CLUB_VALIDATE_FAILED = 2071,
  OPEN_CLUB_INVALIDATE_FAILED = 2072,
  OPEN_CLUB_LACK_OF_ESSENTIALS = 2073,
  OPEN_CLUB_MEMBERSHIP_NOT_FOUND = 2074,
  OPEN_CLUB_MEMBERSHIP_EXPIRED = 2075,
  OPEN_CLUB_LICENSE_NOT_FOUND = 2076,
  OPEN_CLUB_HEART_NEED_MEMBERSHIP = 2077,
  CLUB_CLOSING = 2078,
  CLUB_INVALID_STATE = 2079,
  CLUB_DEPOSIT_ONLY_POSSIVLE_IN_PAUSED_RUNNIG = 2080,
  CLUB_WITHDRAW_FAIL_INVALID_STATE = 2081,
  CLUB_WITHDRAW_FAIL_BET_ONGOING = 2082,
  CLUB_WITHDRAW_FAIL_ONGOING_SOLUBLE_HALF = 2083,
  CLUB_WITHDRAW_FAIL_ONGOING_ONCE_DONE = 2084,
  JOIN_CLUB_MEMBER_LIMITED = 2085,
  JOIN_CLUB_AGENT_DIFFERENT = 2086,
  JOIN_CLUB_ODDSMAKER_CANT_JOIN = 2087,
  JOIN_CLUB_INVALID_MY_CLUB_STATE = 2088,
  JOIN_CLUB_INVALID_CLUB_MEMBER_STATE = 2089,
  JOIN_CLUB_ONCE_EXPELLED = 2090,
  REQUEST_CLUB_INVALID_STATE = 2091,
  REQUEST_MEMBER_INVALID_STATE = 2092,
  REQUEST_MY_CLUB_INVALID_STATE = 2093,
  REQUEST_INVALID_AGENT = 2094,
  SET_CLUB_ALREADY_APPLY = 2095,
  SET_CLUB_MEMBER_ALREADY_APPLY = 2096,
  SET_CLUB_HEART_FREE_NOT_ALLOWED = 2097,
  OUT_OF_BOUND = 2098,
  BET_FAIL_FEED_SYSTEM_DELAYED = 2099,
  BET_FAIL_INVALID_BET_TYPE_ON = 2100,
  BET_FAIL_INVALID_MEMBER_STATE = 2101,
  BET_FAIL_INVALID_BET_CALL = 2102,
  BET_FAIL_INSUFFICIENT_MONEY = 2103,
  BET_FAIL_INSUFFICIENT_SOLUBLE = 2104,
  BET_FAIL_UNALLOWED_CALL_TYPE = 2105,
  BET_FAIL_MATCH_NOT_FOUND = 2106,
  BET_FAIL_PRE_MATCH_STARTED = 2107,
  BET_FAIL_LIVE_ODDS_NOT_STARTED = 2108,
  BET_FAIL_BREAK_CROSS_MULTI_RULE = 2109,
  BET_FAIL_ODDS_NOT_FOUND = 2110,
  BET_FAIL_ODDS_FILED_NOT_FOUND = 2111,
  BET_FAIL_INVALID_ODDSTYPE = 2112,
  BET_FAIL_INVALID_LIVEODDS = 2113,
  BET_FAIL_INVALID_MATCHUP_CATEGORY = 2114,
  BET_FAIL_POST_RULE_ODDS = 2115,
  BET_FAIL_SPORT_RULE_NOT_FOUND = 2116,
  BET_FAIL_CATEGORY_RULE_NOT_FOUND = 2117,
  BET_FAIL_TOURNAMENT_RULE_NOT_FOUND = 2118,
  BET_FAIL_SPORT_ODDSTYPE_RULE_NOT_FOUND = 2119,
  BET_FAIL_DIFFRENT_RATE = 2120,
  BET_FAIL_OUTCOME_EXISTS = 2121,
  BET_FAIL_MEMBER_SINGLE_BET_NOT_PERMITED = 2122,
  BET_FAIL_MEMBER_MULTI_BET_NOT_PERMITED = 2123,
  BET_FAIL_MEMBER_MULTI_BET_FOLD_OUT_OF_BOUND = 2124,
  BET_FAIL_RULE_SINGLE_BET_NOT_SUPPORTED = 2125,
  BET_FAIL_RULE_MULTI_BET_NOT_SUPPORTED = 2126,
  BET_FAIL_LESSER_BETTING_MIN = 2127,
  BET_FAIL_GREATER_BETTING_MAX = 2128,
  BET_FAIL_GREATER_HIT_MAX = 2129,
  BET_FAIL_GREATER_LIMIT_BETTING_RATE = 2130,
  BET_FAIL_GREATER_LIMIT_AXIS_MAX = 2131,
  BET_FAIL_GREATER_LIMIT_ODDS_BET_MONEY = 2132,
  BET_FAIL_INACTIVE_LIVE = 2133,
  BET_FAIL_EXIST_PROGRESS_BETTING = 2134,
  BET_FAIL_ALREADY_OUTCOME = 2135,
  BET_FAIL_DAILY_BET_COUNT_LIMITED_IN_CLUB = 2136,
  BET_FAIL_INVALID_DAY_CLUB_SET = 2137,
  BET_CANCEL_FAIL_DISABLE_CANCEL = 2138,
  BET_CANCEL_FAIL_ALREADY_START = 2139,
  BET_CANCEL_FAIL_TIMEOUT = 2140,
  BET_CANCEL_FAIL_NOT_EXIST_PROGRESS_BETTING = 2141,
  SET_POST_RULE_FAIL = 2142,
  SET_POST_RULE_FAIL_PRE_MATCH_STARTED = 2143,
  SET_POST_RULE_FAIL_MATCH_ODDS_NOT_FOUND = 2144,
  SET_POST_RULE_FAIL_LIVE_MATCH_NOT_PLAYING = 2145,
  SET_POST_RULE_FAIL_LIVE_ODDS_NOT_FOUND = 2146,
  PUBLISH_PICK_FAIL_NOT_PERMITTED = 2147,
  PUBLISH_PICK_FAIL_INVALID_BET_HIT_STATE = 2148,
  PUBLISH_PICK_FAIL_PUBLISH_TIME_LIMITED = 2149,
  PUBLISH_PICK_FAIL_ALREADY_REGISTERED_MARKET = 2150,
  PUBLISH_PICK_FAIL_ONCE_CREATED = 2151,
  BUY_PICK_FAIL_PICK_MARKET_NOT_FOUND = 2152,
  BUY_PICK_FAIL_PURCHASE_TIME_LIMITED = 2153,
  BUY_PICK_FAIL_PICK_YOURS = 2154,
  BUY_PICK_FAIL_NOT_CLUB_MEMBER = 2155,
  BUY_PICK_FAIL_INSUFFICIENT_MONEY = 2156,
  BUY_PICK_FAIL_INSUFFICIENT_TICKET = 2157,
  REGISTER_PICK_MARKET_FAIL_TIME_LIMITED = 2158,
  FIRE_PICK_FAIL_BETTING_TIME_LIMITED = 2159,
  FIRE_PICK_FAIL_INVALID_BET_STATE = 2160,
  DIBS_CLUB_FAIL_MY_CLUB = 2161,
  DIBS_CLUB_FAIL_ALREADY_APPLY = 2162,
  LIVE_MATCH_INVALID = 2163,
  LIVE_MATCH_NOT_STARTED = 2164,
  LIVE_MATCH_ENDED = 2165,
  LIVE_MATCH_RETIRED = 2166,
  LIVE_MATCH_BET_INVALID = 2167,
  LIVE_MATCH_BET_STOPPED = 2168,
  INVALID_PRESENT_BOX_OPEN_TIME = 2169,
  MISSION_FAIL_DISAPEAR = 2170,
  MISSION_FAIL_UNKNOWN = 2171,
  MISSION_FAIL_CONDITION = 2172,
  MISSION_FAIL_ALREADY_REWARD = 2173,
  INAPP_PURCHASE_FAIL_INVALID_PURCHASE_DATA = 2174,
  INAPP_PURCHASE_FAIL_TICKET_NOT_FOUND = 2175,
  INAPP_PURCHASE_FAIL_INVALID_TICKET_STATE = 2176,
  INAPP_CONSUME_FAIL_INVALID_PURCHASE_DATA = 2177,
  INAPP_CONSUME_FAIL_TICKET_NOT_FOUND = 2178,
  INAPP_CONSUME_FAIL_INVALID_TICKET_STATE = 2179,
  INAPP_CONSUME_FAIL_INVALID_RECEIPT = 2180,
  ADULT_AUTH_NEED = 2181,
  ADULT_AUTH_EXPIRED = 2182,
  ADULT_AUTH_APPROACH = 2183,
  ACCOUNT_NEED_UNIFIED = 2184,
  RESERVED_CLUB_NAME = 2185,
  RESERVED_NICKNAME = 2186,
  RESERVED_NOT_CONFIRM = 2187,
  RESERVED_NOT_EXIST = 2188,
  RESERVED_NOT_REG_PHONE = 2189,
  CLUB_SELF_OUT_FAIL_FOR_ONGOING = 2190,
  EVENT_NOT_AVAILABLE = 2191,
  BINARY_KEY_NOT_EXIST = 2192,
  BINARY_API_UNSTABLE = 2193,
  BINARY_INVALID_BET_TIME = 2194,
  BINARY_GAME_OVER_DATE = 2195,
  BINARY_GAME_BET_NOT_EXIST = 2196,
  BINARY_GAME_RESULT_NOT_YET = 2197,
  COUPON_NOT_FOUND = 2198,
  COUPON_ALREADY_USED_OTHER = 2199,
  COUPON_ALREADY_USED_SELF = 2200,
  COUPON_EXPIRED = 2201,
  COUPON_LIMITED = 2202,
  COUPON_LIMITED_TYPE_ONCE = 2203,
  COUPON_NOT_CERTIFICATED = 2204,
  INVALID_SERVER_STATUS = 2205,
  SERVER_STATUS_QA = 2206,
  SERVER_STATUS_CHECK = 2207,
  SERVER_STATUS_CLOSING = 2208,
  SERVER_STATUS_CHECK_EXIT = 2209,
  INVALID_ACCOUNT_BREAK_AWAY = 2210,
  DIRTY_ACCOUNT_LIMITED = 2211,
  INVALID_CLUB_BOARD_TEXT = 2212,
  ALREADY_CLUB_BOARD_LIKEY = 2213,
  NOT_ENOUGH_COST = 2214,
  BINARY_BET_TIME_OVER = 2215,
  BINARY_INVALID_GAME_STATE = 2216,
  CHAT_BLOCK_USER = 2217,
  CHAT_BLOCK_USER_1M = 2218,
  CHAT_BLOCK_USER_5M = 2219,
  CHAT_BLOCK_USER_10M = 2220,
  CHAT_BLOCK_USER_30M = 2221,
  CHAT_BLOCK_USER_60M = 2222,
  BET_TICKET_INVALID = 2223,
  BET_TICKET_CHECK_BET_RATE = 2224,
  BET_TICKET_NOT_ENOUGH = 2225,
  BET_TICKET_PRODUCT_LIMIT_TIME_CONDITION = 2226,
  BIN_BET_CALLTYPE_LIMIT_SINGLE = 2227,
  BIN_BET_CALLTYPE_LIMIT_MULTI = 2228,
  BET_FAIL_UNAVAILABLE_CROSS_SINGLE_BET = 2229,
  BET_FAIL_UNAVAILABLE_CROSS_MULTI_BET = 2230,
  BET_FAIL_UNAVAILABLE_WDL_SINGLE_BET = 2231,
  BET_FAIL_UNAVAILABLE_WDL_MULTI_BET = 2232,
  BET_FAIL_UNAVAILABLE_HANDI_UN_OVER_SINGLE_BET = 2233,
  BET_FAIL_UNAVAILABLE_HANDI_UN_OVER_MULTI_BET = 2234,
  BET_FAIL_UNAVAILABLE_SPECIAL_SINGLE_BET = 2235,
  BET_FAIL_UNAVAILABLE_SPECIAL_MULTI_BET = 2236,
  BET_FAIL_UNAVAILABLE_LIVE_SINGLE_BET = 2237,
  BET_FAIL_UNAVAILABLE_LIVE_MULTI_BET = 2238,
  BET_FAIL_UNAVAILABLE_MIX_BET = 2239,
  BET_FAIL_TRY_TOO_FREQUENTLY = 2240,
  SET_CLUB_GRADE_FAIL_BET_ONGOING = 2241,
  BUY_ITEM_FAIL_ONLY_MEMBERSHIP = 2242,
  BET_CANCEL_FAIL_NOT_ENOUGH_COMMISION = 2243,
  ALREADY_SAVED_BETTING_HISTORY_SHARE = 2244,
  ALREADY_RECEIVED_ITEM_MESSAGE = 2245,
  TARGET_USER_BLOCKED = 2246,
  TARGET_USER_UNREGISTERED = 2247,
  ALREADY_CLOSE_REQUEST_BETTING_HISTORY = 2248,
  BET_FOLD_NOT_FOUND = 2249,
  MATCH_NOT_ENDED = 2250,
  AUTHENTICATION_FAIL_NOT_ADULT = 2251,
  AUTHENTICATION_FAIL_EMPTY_CI = 2252,
  AUTHENTICATION_FAIL_EMPTY_REQUIRE_INFO = 2253,
  JOIN_USER_FAIL_INVALID_LENGTH = 2254,
  JOIN_USER_FAIL_INVALID_REQUIRE_CHARACTER = 2255,
  JOIN_USER_FAIL_INVALID_ACCOUNT = 2256,
  JOIN_USER_FAIL_INVALID_RECOMMENDER = 2257,
  JOIN_USER_FAIL_INVALID_CIVALUE = 2258,
  JOIN_USER_FAIL_INVALID_INVITOR_NICK_NAME = 2259,
  JOIN_USER_FAIL_INVALID_REGISTRATION_SOURCE = 2260,
  CLOSED_BET_FOLD = 2261,
  LOSS_LIMIT_FAIL_NUMBER_OF_CHANGES_EXCEEDED = 2262,
  BET_FAIL_LOSS_LIMIT_EXCEEDED = 2263,
  FRIEND_INVITATION_NOT_FOUND_NICK = 2264,
  FRIEND_INVITATION_INVALID_CONDITION_NICK = 2265,
  FRIEND_INVITATION_SELF_CERTIFICATION_NICK = 2266,
  FRIEND_INVITATION_ALREADY_REGISTERED = 2267,
  MATCH_NOT_CUSTOM_ACTIVE = 2268,
  ADD_JOB_QUEUE_FAIL_DUPLICATED_KEY = 2269,
  BETTOR_BET_ID_IS_ALREADY_IN_COMPANY_PICK_USE = 2270,
  PROCESSING_LIVE_BET_EXIST = 2271,
  BET_FAIL_INSUFFICIENT_EXTRA_ODDS_ITEM = 2272,
  BET_FAIL_EXCEEDED_MATCH_SCORE = 2273,
  BET_FAIL_INVALID_FOLD_CONDITION_EXTRA_ODDS_ITEM = 2274,
  DAILY_BETTING_EVENT_REWARD_RECEIVE_FAIL_INVALID_CONDITION = 2275,
  DAILY_BETTING_EVENT_REWARD_RECEIVE_FAIL_COUNT_EXCEED = 2276,
  REGIST_SUB_MARKET_FAIL_NOT_ALLOW_SPECIFIER = 2277,
  USER_PENALTY_WRITE = 2278,
  COMMUNICATION_BLOCK_FAIL_BLOCK_DISABLED = 2279,
  COMMUNICATION_BLOCK_FAIL_BLOCK_EXCLUDE_USER = 2280,
  COMMUNICATION_BLOCK_FAIL_BLOCK_USER_LIMIT_EXCEED = 2281,
  COMMUNICATION_BLOCK_FAIL_INVALID_CI_VALUE = 2282,
  COMMUNICATION_BLOCK_FAIL_CI_VALUE_IS_MINE = 2283,
  BET_FAIL_SINGLE_BET_WITH_ADMIN_CONFIG = 2284,
  BET_FAIL_INACTIVE_MARKET = 2285,
  REGISTER_ACCOUNT_TRANSFER_FAIL_NOT_EQUAL_CI = 2286,
  REGISTER_ACCOUNT_TRANSFER_FAIL_ALREADY_EXISTS = 2287,
  REGISTER_ACCOUNT_TRANSFER_DISABLED = 2288,
  CLUB_CONFIGURATION_FAIL_INSUFFICIENT_LIMIT_BETTING_MONEY = 2289,
  CLUB_CONFIGURATION_FAIL_LIMIT_BETTING_MONEY_EXCEED = 2290,
  BET_CATEGORY_SETTING_FAIL_MIX_BETTING = 2291,
  BET_FAIL_LESS_THEN_MINIMUM_LIVE_MATCH_OUTCOME_RATE = 2292,
  ADD_FAVORITE_USER_LIMIT_EXCEEDED = 2293,
  EXTRA_PAYMENT_REWARD_INVALID_CONDITION_TOTAL_AMOUNT = 2294,
  EXTRA_PAYMENT_REWARD_ALREADY_RECEIVED = 2295,
}